import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Normalize a string for generous (diacritic-insensitive) search.
 * Decomposes accented characters (NFD) and strips combining marks,
 * then lowercases the result.  e.g. "Orléans" → "orleans"
 */
export function normalizeString(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
}
